import {
  faCircle,
  faDeleteLeft,
  faSquare,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import React, { useEffect, useState } from "react";
import ColorPicker from "react-best-gradient-color-picker";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  customLinkColor,
  customTextColor,
  customThemeColor,
  customFontFamily,
  customFontSize,
  customNameColor,
  resetStyle,
  iconsThemeDefault,
  imageSize,
  imageShape,
  iconSize,
} from "../../../../slice/style";
import lang from "../../../../assets/lang/icons.json";
import style from "./TempStyle.module.css";
import SwitchBtn from "../../FormControl/SwitchButton/SwitchBtn";

// import lang from "../../../../assets/lang/icons.json";

export default function Style() {
  const userStyle = useSelector((state) => state.userStyle);
  const dispatch = useDispatch();
  const isAuth = localStorage.getItem("auth_token") ? true : false;

  const [textColor, setTextColor] = useState(
    userStyle.customTextColor[0].textColor
  );
  const [textname, setTextName] = useState(
    userStyle.customNameColor[0].textName
  );
  const [themeColor, setThemeColor] = useState(
    userStyle.customThemeColor[0].themeColor
  );
  const [iconsTheme, setIconsThemeDefault] = useState(
    userStyle.iconsThemeDefault[0].iconsThemeDefault
  );

  const [linkColor, setLinkColor] = useState(
    userStyle.customLinkColor[0].linkColor
  );

  const [fontFamily, setFontFamily] = useState(
    userStyle.customFontFamily[0].fontFamily
  );

  const [fontSize, setFontSize] = useState(
    userStyle.customFontSize[0].fontSize !== null
      ? userStyle.customFontSize[0].fontSize
      : 1
  );

  const [imageShapeValue, setImageShapeValue] = useState(
    userStyle.imageShape[0].imageShape
  );

  const [imageSizeKey, setImageSizeKey] = useState(
    userStyle.imageSize[0].imageSize
  );

  const [iconsSizekey, setIconsSizeKey] = useState(
    userStyle.iconSize[0].iconSize
  );

  const [toggleColorPicker1, settoggleColorPicker1] = useState("none");
  const [toggleColorPicker2, settoggleColorPicker2] = useState("none");
  const [toggleColorPicker3, settoggleColorPicker3] = useState("none");
  const [toggleColorPicker4, settoggleColorPicker4] = useState("none");

  const handleTextColor = () => {
    toggleColorPicker1 === "block"
      ? settoggleColorPicker1("none")
      : settoggleColorPicker1("block");
    settoggleColorPicker2("none");
    settoggleColorPicker3("none");
    settoggleColorPicker4("none");
  };

  const handleThemeColor = () => {
    toggleColorPicker2 === "block"
      ? settoggleColorPicker2("none")
      : settoggleColorPicker2("block");
    settoggleColorPicker1("none");
    settoggleColorPicker3("none");
    settoggleColorPicker4("none");
  };

  const handleLinkColor = () => {
    toggleColorPicker3 === "block"
      ? settoggleColorPicker3("none")
      : settoggleColorPicker3("block");
    settoggleColorPicker2("none");
    settoggleColorPicker1("none");
    settoggleColorPicker4("none");
  };

  const handleNameColor = () => {
    toggleColorPicker4 === "block"
      ? settoggleColorPicker4("none")
      : settoggleColorPicker4("block");
    settoggleColorPicker2("none");
    settoggleColorPicker1("none");
    settoggleColorPicker3("none");
  };

  const resetStyleBtn = (e) => {
    e.preventDefault();
    setTextColor("rgba(0, 0, 0, 1)");
    setTextName("rgba(96, 62, 198, 1)");
    setThemeColor("rgba(254, 88, 96, 1)");
    setIconsThemeDefault(false);
    setLinkColor("rgba(44, 121, 214,1)");
    setFontFamily("Arial");
    setFontSize("1");
    setImageSizeKey(1);
    setImageShapeValue("square");
    setIconsSizeKey("1");
    dispatch(resetStyle(true));

    toast.dismiss();
    toast.info("Style Reset Sucessfully ", {
      closeOnClick: true,
      theme: "colored",
    });
  };

  // show small , medium , large on change font-size
  const fontSizename = () => {
    if (fontSize === 1) {
      return (
        <p className={` ${style.customStyInput2} mt-2 text-center `}>medium</p>
      );
    }
    if (fontSize === 0) {
      return (
        <p className={` ${style.customStyInput2} mt-2 text-start `}>small</p>
      );
    }
    if (fontSize === 2) {
      return (
        <p className={` ${style.customStyInput2} mt-2 text-end `}>large</p>
      );
    }
  };

  // convert rgba to hex value
  function trim(str) {
    return str.replace(/^\s+|\s+$/gm, "");
  }

  function rgbaToHex(rgba) {
    var inParts = rgba.substring(rgba.indexOf("(")).split(","),
      r = parseInt(trim(inParts[0].substring(1)), 10),
      g = parseInt(trim(inParts[1]), 10),
      b = parseInt(trim(inParts[2]), 10),
      a = parseFloat(
        trim(inParts[3].substring(0, inParts[3].length - 1))
      ).toFixed(2);
    var outParts = [
      r.toString(16),
      g.toString(16),
      b.toString(16),
      Math.round(a * 255)
        .toString(16)
        .substring(0, 2),
    ];
    // Pad single-digit output values
    outParts.forEach(function (part, i) {
      if (part.length === 1) {
        outParts[i] = "0" + part;
      }
    });
    return "#" + outParts.join("");
  }

  const fetch = async () => {
    try {
      const response = await axios.get("/getUser");
      const user = await response.data.user;
      if (user.current_temp_id !== null) {
        setTextColor(user.edit_template.text_color);
        setLinkColor(user.edit_template.link_color);
        setTextName(user.edit_template.text_name);
        setThemeColor(user.edit_template.theme_color);
        setFontSize(user.edit_template.font_size);
        setFontFamily(user.edit_template.font_family);

        setIconsThemeDefault(user.edit_template.theme_icons);
        setIconsSizeKey(user.edit_template.icon_size);

        setImageShapeValue(user.edit_template.image_shape);
        setImageSizeKey(user.edit_template.image_size);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (isAuth) {
      fetch();
    }
  }, [isAuth, dispatch]);

  useEffect(() => {
    dispatch(customTextColor(textColor));
    dispatch(customThemeColor(themeColor));
    dispatch(customLinkColor(linkColor));
    dispatch(customFontFamily(fontFamily));
    dispatch(customFontSize(fontSize));
    dispatch(customNameColor(textname));
    dispatch(iconsThemeDefault(iconsTheme));
    dispatch(imageSize(imageSizeKey));
    dispatch(imageShape(imageShapeValue));
    dispatch(iconSize(iconsSizekey));
  }, [
    linkColor,
    textColor,
    themeColor,
    iconsTheme,
    fontFamily,
    fontSize,
    textname,
    imageSizeKey,
    imageShapeValue,
    iconsSizekey,
    dispatch,
  ]);

  return (
    <div className={`container ${style.customStyle}`}>
      <div className="m-xxl-3 m-2">
        <span className="custom-header">
          Stylize Your Signature
          <button
            className={`btn btn-sm btn-primary ms-3 text-skyblue ${style.resetStyle}`}
            onClick={resetStyleBtn}
          >
            <FontAwesomeIcon icon={faDeleteLeft} /> reset to default
          </button>
        </span>

        <h6 className="fw-bold mt-4 text-orange">Color </h6>
        <div className="mb-4 position-relative">
          <label className="d-block mb-2 custom-lable">Select Name Color</label>
          <div className="d-flex align-items-center">
            <span className="pe-2 fs-4">#</span>
            <input
              type="text"
              value={rgbaToHex(textname).substring(1).slice(0, -2)}
              className={`${style.customStyInput} form-control`}
              disabled
            />
            <button
              className={`${style.customStyColorPicker}`}
              onClick={handleNameColor}
              style={{
                background: textname,
                width: "45px",
                height: "45px",
                borderRadius: "50%",
              }}
            />
          </div>
          <ColorPicker
            style={{ display: toggleColorPicker4 }}
            className={`${style.customColorPicker} my-2  `}
            value={textname}
            onChange={setTextName}
            hideOpacity={true}
            hideControls={true}
            hidePresets={true}
            width={250}
            height={250}
          />
        </div>

        <div className="my-4 position-relative">
          <label className="d-block mb-2 custom-lable">Select Text Color</label>
          <div className="d-flex align-items-center">
            <span className="pe-2 fs-4">#</span>
            <input
              type="text"
              value={rgbaToHex(textColor).substring(1).slice(0, -2)}
              className={`${style.customStyInput} form-control`}
              disabled
            />
            <button
              className={`${style.customStyColorPicker}`}
              onClick={handleTextColor}
              style={{
                background: textColor,
                width: "45px",
                height: "45px",
                borderRadius: "50%",
              }}
            />
          </div>
          <ColorPicker
            style={{ display: toggleColorPicker1 }}
            className={`${style.customColorPicker} my-2  `}
            value={textColor}
            onChange={setTextColor}
            hideOpacity={true}
            hideControls={true}
            hidePresets={true}
            width={250}
            height={250}
          />
        </div>

        <div className="my-4 position-relative">
          <label className="d-block mb-2 custom-lable">
            Select Icons/Theme Color
          </label>

          <div className="d-flex align-items-center">
            <span className="pe-2 fs-4">#</span>
            <input
              type="text"
              value={rgbaToHex(themeColor).substring(1).slice(0, -2)}
              className={`${style.customStyInput} form-control`}
              disabled
            />
            <button
              className={`${style.customStyColorPicker}`}
              onClick={handleThemeColor}
              style={{
                background: themeColor,
                width: "45px",
                height: "45px",
                borderRadius: "50%",
              }}
            />
          </div>
          <ColorPicker
            style={{ display: toggleColorPicker2 }}
            className={`${style.customColorPicker} my-2  `}
            value={themeColor}
            onChange={setThemeColor}
            hideOpacity={true}
            hideControls={true}
            hidePresets={true}
            width={250}
            height={250}
          />
        </div>

        <div className="mt-4  position-relative">
          <label className="d-block mb-2 custom-lable">
            Select Border/Background Color
          </label>
          <div className="d-flex align-items-center">
            <span className="pe-2 fs-4">#</span>
            <input
              type="text"
              value={rgbaToHex(linkColor).substring(1).slice(0, -2)}
              className={`${style.customStyInput} form-control`}
              disabled
            />
            <button
              className={`${style.customStyColorPicker}`}
              onClick={handleLinkColor}
              style={{
                background: linkColor,
                width: "45px",
                height: "45px",
                borderRadius: "50%",
              }}
            />
          </div>
          <ColorPicker
            style={{ display: toggleColorPicker3 }}
            className={`${style.customColorPicker} my-2  `}
            value={linkColor}
            onChange={setLinkColor}
            hideOpacity={true}
            hideControls={true}
            hidePresets={true}
            width={250}
            height={250}
          />
        </div>
        <div className="d-flex flex-wrap ">
          <h6 className="fw-bold mt-4 text-orange w-100">Icons </h6>
          <div className="mb-4 position-relative d-flex align-items-center flex-wrap w-100">
            <div className="w-50">
              <span>Match Icons With Theme</span>
            </div>
            <div className="w-50">
              <SwitchBtn
                isOn={iconsTheme}
                handleToggle={() => setIconsThemeDefault(!iconsTheme)}
              />
            </div>
          </div>

          <div className="mb-4 position-relative d-flex align-items-center flex-wrap w-100">
            <div className="w-50">
              <label className="d-block custom-lable ">Icon Size</label>
            </div>
            <div className="w-50">
              <input
                className={`${style.customStyInput2} `}
                type="range"
                step={1}
                min={0}
                max={2}
                value={iconsSizekey}
                onChange={(event) => {
                  setIconsSizeKey(Number(event.target.value));
                }}
              />
            </div>
          </div>
        </div>

        <div className="d-flex flex-wrap ">
          <h6 className="fw-bold mt-4 text-orange w-100">Font </h6>
          <div className="mb-4 position-relative d-flex align-items-center flex-wrap w-100">
            <div className="w-50">
              <label className="d-block mb-2 custom-lable ">Font Family</label>
            </div>
            <div className="w-50">
              <select
                name="fontFamily"
                value={fontFamily}
                onChange={(event) => setFontFamily(event.target.value)}
                className={`${style.customStyInput2} bg-blue text-white`}
              >
                <option value="Arial">Arial</option>
                <option value="Georgia">Georgia</option>
                <option value="Lucida Sans Unicode">Lucida Sans Unicode</option>
                <option value="Times New Roman">Times New Roman</option>
                <option value="Trebuchet MS">Trebuchet MS</option>
                <option value="Verdana">Verdana</option>
                <option value="Courier New">Courier New </option>
                <option value="Candara">Candara</option>
                <option value="Calibri">Calibri</option>
              </select>
            </div>
          </div>

          <div className="mb-4 position-relative d-flex align-items-center flex-wrap w-100">
            <div className="w-50">
              <label className="d-block custom-lable "> Font Size</label>
            </div>
            <div className="w-50">
              {/* {fontSizename()} */}
              <input
                className={`${style.customStyInput2} `}
                type="range"
                step={1}
                min={0}
                max={2}
                value={fontSize}
                onChange={(event) => setFontSize(Number(event.target.value))}
              />
            </div>
          </div>
        </div>

        <div className="d-flex flex-wrap ">
          <h6 className="fw-bold mt-4 text-orange w-100">Image </h6>
          <div className="mb-4 position-relative d-flex align-items-center flex-wrap w-100">
            <div className="w-50">
              <label className="d-block custom-lable "> Shape</label>
            </div>
            <div className={`${style.imageShapeIcons}`}>
              <div
                className={`${style.imageShapeIcon} ${
                  imageShapeValue === "square"
                    ? `${style.ImageShapeSelected}`
                    : ""
                }`}
                data-value="square"
                onClick={() => setImageShapeValue("square")}
              >
                <FontAwesomeIcon
                  icon={faSquare}
                  onClick={() => setImageShapeValue("square")}
                />
              </div>

              <div
                className={`${style.imageShapeIcon} ${
                  imageShapeValue === "circle"
                    ? `${style.ImageShapeSelected}`
                    : ""
                }`}
                data-value="circle"
                onClick={() => setImageShapeValue("circle")}
              >
                <FontAwesomeIcon
                  icon={faCircle}
                  onClick={() => setImageShapeValue("circle")}
                />
              </div>
            </div>
          </div>

          <div className="mb-4 position-relative d-flex align-items-center flex-wrap w-100">
            <div className="w-50">
              <label className="d-block custom-lable "> Size</label>
            </div>
            <div className="w-50">
              <input
                className={`${style.customStyInput2} `}
                type="range"
                step={1}
                min={0}
                max={2}
                value={imageSizeKey}
                onChange={(event) => {
                  setImageSizeKey(Number(event.target.value));
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
